<template lang="pug">
v-container
  crud-scroll-details(
    v-if="agreementsFiltered.length"
    :detailsComponent="detailsComponent"
    :adapter="adapter"
    :filters="filters"
  )
    template(#list-item="{ item, opencu }")
      //- v-list-item-icon.mr-0.pt-1
      //-   v-progress-circular(
      //-     :value="100"
      //-     :color="item.is_concluded ? 'success' : 'error'"
      //-     size="16"
      //-   )
      v-list-item-avatar
        v-avatar
          v-icon(
          ) {{ item.users.length > 1 ? 'mdi-account-multiple' : 'mdi-account' }}
      v-list-item-content
        v-list-item-title {{ item.number }}
      v-alert.mb-0(
        dense text
        :color="item.isPaymentPrePayment && item.is_active ? 'success' : 'error'"
      )
        .text-h6 {{ item.is_active ? `${item.paymentPercent} %` : 'Не активен' }}
  v-alert(v-else type="info") Нет ни одного типового договора
</template>

<script>
import CrudScrollDetails from '@/components/Global/crudScrollDetails/index.vue';
import ListDetail from './ListDetail.vue';

export default {
  components: {
    CrudScrollDetails,
  },
  props: {
    agreements: { type: Object, required: true },
  },
  data() {
    return {
      detailsComponent: {
        component: ListDetail,
      },
      filters: [
        {
          is: 'v-select',
          attrs: {
            label: '',
          },
        },
      ],
    };
  },
  computed: {
    agreementsFiltered() {
      return Object.values(this.agreements).filter((i) => !!i.id);
    },
  },

  methods: {
    adapter({ number, page }) {
      const ids = this.agreementsFiltered.map((i) => i.id);
      return this.$api.contracts.getContractsModel({
        expand: 'users,transactions,qr_code,typical_contract_discount,typical_contract,preview_document,document,is_signed_executor,is_signed_customer',
        'search[typical_contract_id]': ids,
        'search[is_active]': true,
        sort: 'created_at',
        page,
        ...number ? { 'search[number]': number } : {},
      });
    },
  },
};
</script>
